<template>
  <div>
    <apexchart v-if="percent >= 10" type='radialBar' height="350" :options="chartOptions" :series="[percent]"></apexchart>
    <div v-else-if="$parent.low_warning" class="alert alert-warning low_alert" role="alert">{{ $parent.low_warning || "Loading..." }}</div>
    <div v-else class="low_alert"></div>
  </div>
</template>

<script>

var options = {
        plotOptions: {
          radialBar: {
            startAngle: -135,
            endAngle: 225,
            hollow: {
              margin: 0,
              size: '60%', // '70%',
              background: '#fff',
              image: undefined,
              imageOffsetX: 0,
              imageOffsetY: 0,
              position: 'front',
              dropShadow: {
                enabled: true,
                top: -3,
                left: 0,
                blur: 4,
                opacity: 0.2
              }
            },
            track: {
              background: '#fff',
              strokeWidth: '150%', //'67%',
              margin: 0, // margin is in pixels
              dropShadow: {
                enabled: true,
                top: 3,
                left: 0,
                blur: 4,
                opacity: 0.35
              }
            },
            dataLabels: {
              show: true,
              name: { offsetY: -10, color: '#', fontSize: '30px' },
              value: { formatter: (val) => `${parseInt(val)}%`, fontSize: '36px', show: true, }
            }
          }
        },
        fill: {
          type: 'gradient',
          gradient: {
            shade: 'dark',
            type: 'horizontal',
            shadeIntensity: 0.5,
            gradientToColors: ['#41B883'],
            inverseColors: true,
            opacityFrom: 1,
            opacityTo: 1,
            stops: [0, 100]
          }
        },
        stroke: {  lineCap: 'round'  },
        labels: ['Percent'],
      }

import dbservice from '../services/dbservice.js';

export default {
  name: 'ApexChart',
  data() {
    return {
      chartOptions: options,
      percent: 15
    }
  },
  created() {
    let userRef = dbservice.getUserRef();
    this.$store.state.snapshots.push(
      userRef.onSnapshot(doc => {

        if (doc.data().temp_percent) {
          this.percent = doc.data().temp_percent  
        } else {
          this.percent = doc.data().percent
        }
        
      })
    )
  }
}
</script>

<style>
.low_alert {
  margin: 150px 10%;
}
</style>
